import modelSingleton from '@pcln/fly-model'

const Model = modelSingleton()

const adModel = new Model()

export { adModel }
